// extracted by mini-css-extract-plugin
module.exports = {"customer":"styles_customer__NhVmC","primaryUser":"styles_primaryUser__1AexO"};